export const INCREMENT_COLLECTED_TOTAL_PRICE = 'INCREMENT_COLLECTED_TOTAL_PRICE';
export const DECREMENT_COLLECTED_TOTAL_PRICE = 'DECREMENT_COLLECTED_TOTAL_PRICE';
export const SET_COLLECTED_TOTAL_PRICE = 'SET_COLLECTED_TOTAL_PRICE';
